import { NameModel } from "../../dataList/station/name.model";
import { GenericModel } from "../../../generic.model";
import { makeModel } from "../../../../service/utils/utils.service";
import { StreetModel } from "./street.model";
import { CountryModel } from "./country.model";

export class AddressModel extends GenericModel {
    public zipCode: string;
    public state: string;
    public city: NameModel[];
    public country: CountryModel;
    public streetArray: StreetModel[];
    public streetLineArray: string[];
    public textLineArray: string[];

    public full: string;

    protected fromJson(json?: any): boolean {
        this.zipCode = json.zipCode ?? null;
        this.state = json.state?.code ?? null;
        this.city = makeModel(json.city, NameModel);
        this.country = makeModel(json.country, CountryModel);
        this.streetArray = makeModel(json.streetArray, StreetModel);
        this.streetLineArray = json.streetLineArray ?? null;
        this.textLineArray = json.textLineArray ?? null;
        this.full = this.textLineArray && this.zipCode ? this.textLineArray.join(' ') + ' ' + this.zipCode : null;
        return this.isValid();
    }

    protected isValid(): boolean {
        return this.full !== null;
    }
}